var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"border px-1"},[_vm._v(_vm._s(_vm.dispStr))])
}
var staticRenderFns = []

export { render, staticRenderFns }